module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare-f5197740892ac5c348851c721c993a64.png";